module.exports = __webpack_public_path__ + "assets/img/06a.dbe27321.png";